import { Component, OnInit, isDevMode } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  ngOnInit() {
    if (!this.isLoggedIn()) {
      location.assign('/api/login');
    }
  }

  public isLoggedIn() {
    return isDevMode() || moment().unix() < this.getExpiration();
  }

  getExpiration(): number {
    return parseInt(localStorage.getItem("expires_at"));
  }
}
